import { styled } from "@mui/material/styles";
import { FormControl, Typography, Grid, TextField, FormHelperText } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import { InfoOutlined } from "@mui/icons-material";

export const ModalContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
}));

export const ModalContainerText = styled(Typography)<{ color?: string }>(({ color }) => ({
  font: "600 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  color: "#344054",
}));

export const Body = styled(Grid)(() => ({
  maxHeight: "calc(90vh - 194px)",
}));

export const MFormControl = styled(FormControl)(({ theme, error, disabled }) => ({
  width: "100%",

  "& fieldset": {
    borderColor: `${error ? colors.error600 : colors.gray300}`,
  },

  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: `${
      // eslint-disable-next-line no-nested-ternary
      disabled ? "none" : error ? colors.error600 : theme.palette.primary.main
    } !important`,
  },
  "& .MuiSelect-select:focus": {
    backgroundColor: "transparent",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: `${error ? colors.error600 : theme.palette.primary.main}`,
  },
}));

export const FieldLabel = styled("span")({
  font: "600 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: "#98A2B3",
});

export const TotalCharactersLabel = styled("span")({
  font: "400 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  color: "#475467",
});

export const InformationCharactersLabel = styled("span")({
  font: "400 12px Manrope",
  lineHeight: "16px",
  letterSpacing: "0.4px",
  color: "#667085",
});

export const TextAreaField = styled(TextField)(({ disabled }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: disabled ? colors.gray50 : colors.white,
    borderRadius: "8px",
    color: colors.gray500,
    font: "400 14px Manrope",
    lineHeight: "20px",
    letterSpacing: "0.25px",
  },
}));

export const ErrorContainer = styled(FormHelperText)(() => ({
  font: "400 14px Manrope",
  lineHeight: "24px",
  color: colors.error600,
  alignItems: "center",
  display: "flex",
  margin: 0,
}));

export const ErrorIcon = styled(InfoOutlined)(() => ({
  marginRight: "5px",
}));
